import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 8.488 23.818"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M7.282 0a1.207 1.207 0 0 1 1.044 1.81l-5.719 9.906a.386.386 0 0 0 0 .386l5.719 9.906a1.207 1.207 0 0 1-2.09 1.207L.251 12.849a1.878 1.878 0 0 1 0-1.878L6.236.605A1.206 1.206 0 0 1 7.282 0Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }